import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Navigation from "@rocketseat/gatsby-theme-docs/src/components/Docs/PostNav";
export const _frontmatter = {
  "title": "Ishan Manishkumar Sheth",
  "description": "Ishan Sheth (imsheth) is a seasoned polyglot and can be found in the terminal, the browser, eating, cooking or amongst nature. As a software engineer, he has experienced the rollercoaster journeys of building products from the ground up, onboarding the first customers for products which were eventually acquired and has also offered specialized consultations to corporations which operate at a multi million dollar scale. Owing to this he has got communication, bringing order to chaos and closure under his belt, which are now his forte. Trance music gets him high and keeps him going on with life.",
  "image": "/meta/imsheth.jpg",
  "disableTableOfContents": true
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "ishan-manishkumar-sheth",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ishan-manishkumar-sheth",
        "aria-label": "ishan manishkumar sheth permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Ishan Manishkumar Sheth`}</h1>
    <img src="/meta/imsheth.jpg" alt="imsheth" align="left" style={{
      "marginBottom": ".5rem"
    }} />
    <p><strong parentName="p">{`Ishan`}</strong>{` is a seasoned polyglot and can be found in the terminal, the browser, eating, cooking or amongst nature. As a software engineer, he has experienced the rollercoaster journeys of building products from the ground up, onboarding the first customers for products which were eventually acquired and has also offered specialized consultations to corporations which operate at a multi million dollar scale. Owing to this he has got communication, bringing order to chaos and closure under his belt, which are now his forte. Trance music gets him high and keeps him going on with life.`}</p>
    <p><inlineCode parentName="p">{`#imsheth`}</inlineCode>{` `}<inlineCode parentName="p">{`#ishansheth`}</inlineCode>{` `}<inlineCode parentName="p">{`#polyglot`}</inlineCode>{` `}<inlineCode parentName="p">{`#softwarearchitect`}</inlineCode>{` `}<inlineCode parentName="p">{`#software`}</inlineCode>{` `}<inlineCode parentName="p">{`#architect`}</inlineCode>{` `}<inlineCode parentName="p">{`#cto`}</inlineCode>{` `}<inlineCode parentName="p">{`#vpengineering`}</inlineCode>{` `}<inlineCode parentName="p">{`#engineeringmanager`}</inlineCode>{` `}<inlineCode parentName="p">{`#leadsoftwareengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#lead`}</inlineCode>{` `}<inlineCode parentName="p">{`#softwareengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#productengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#dataengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#cloudengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#consultingsoftwareengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#softwareconsultant`}</inlineCode>{` `}<inlineCode parentName="p">{`#consultant`}</inlineCode>{` `}<inlineCode parentName="p">{`#leadconsultant`}</inlineCode>{` `}<inlineCode parentName="p">{`#fullstack`}</inlineCode>{` `}<inlineCode parentName="p">{`#fullstacksoftwareengineer`}</inlineCode>{` `}<inlineCode parentName="p">{`#terminal`}</inlineCode>{` `}<inlineCode parentName="p">{`#browser`}</inlineCode>{` `}<inlineCode parentName="p">{`#cloud`}</inlineCode>{` `}<inlineCode parentName="p">{`#programming`}</inlineCode>{` `}<inlineCode parentName="p">{`#development`}</inlineCode>{` `}<inlineCode parentName="p">{`#code`}</inlineCode>{` `}<inlineCode parentName="p">{`#food`}</inlineCode>{` `}<inlineCode parentName="p">{`#cooking`}</inlineCode>{` `}<inlineCode parentName="p">{`#eating`}</inlineCode>{` `}<inlineCode parentName="p">{`#nature`}</inlineCode>{` `}<inlineCode parentName="p">{`#travel`}</inlineCode>{` `}<inlineCode parentName="p">{`#trance`}</inlineCode>{` `}<inlineCode parentName="p">{`#india`}</inlineCode>{` `}<inlineCode parentName="p">{`#gujarat`}</inlineCode>{` `}<inlineCode parentName="p">{`#gujarati`}</inlineCode>{` `}<inlineCode parentName="p">{`#vadodara`}</inlineCode>{` `}<inlineCode parentName="p">{`#baroda`}</inlineCode>{` `}<inlineCode parentName="p">{`#karnataka`}</inlineCode>{` `}<inlineCode parentName="p">{`#bangalore`}</inlineCode>{` `}<inlineCode parentName="p">{`#bengaluru`}</inlineCode>{` `}<inlineCode parentName="p">{`#canada`}</inlineCode>{` `}<inlineCode parentName="p">{`#ontario`}</inlineCode>{` `}<inlineCode parentName="p">{`#toronto`}</inlineCode>{` `}<inlineCode parentName="p">{`#torontonian`}</inlineCode>{` `}<inlineCode parentName="p">{`#blog`}</inlineCode>{` `}<inlineCode parentName="p">{`#vegetarian`}</inlineCode>{` `}<inlineCode parentName="p">{`#eggiterian`}</inlineCode>{` `}<inlineCode parentName="p">{`#foodgasm`}</inlineCode>{` `}<inlineCode parentName="p">{`#psychology`}</inlineCode></p>
    <hr></hr>
    <div {...{
      "style": {
        "textAlign": "left",
        "marginTop": "0.55rem",
        "marginBottom": "0.40rem"
      }
    }}>{`
  `}<a parentName="div" {...{
        "href": "https://twitter.com/theimsheth",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/twitter.svg",
          "alt": "twitter",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://github.com/imsheth",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/github.svg",
          "alt": "github",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://www.npmjs.com/~imsheth",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/npm.svg",
          "alt": "npm",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://stackoverflow.com/users/3152654/imsheth?tab=profile",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/stackoverflow.svg",
          "alt": "stackoverflow",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://in.linkedin.com/in/imsheth",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/linkedin.svg",
          "alt": "linkedin",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://instagram.com/imsheth/",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/instagram.svg",
          "alt": "instagram",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://www.facebook.com/imsheth",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/facebook.svg",
          "alt": "facebook",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://open.spotify.com/user/orekqqr23uij1ehi7upg9akat?si=xXA0ZUqxQW2GgFYzdXgAOA&nd=1",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/spotify.svg",
          "alt": "spotify",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>{`
  `}<a parentName="div" {...{
        "href": "https://www.tvshowtime.com/1589595",
        "target": "_blank",
        "rel": "noopener noreferrer",
        "style": {
          "textDecoration": "none"
        }
      }}>{`
    `}<img parentName="a" {...{
          "src": "/social/tvtime.svg",
          "alt": "tvshowtime",
          "style": {
            "height": "32px",
            "width": "32px",
            "margin": ".2rem"
          }
        }}></img>{`
  `}</a>
    </div>

    <Navigation prev={null} next={{
      label: "Tech",
      link: "/posts/tags/tech"
    }} mdxType="Navigation" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      